import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=54825b60&scoped=true"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&id=54825b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54825b60",
  null
  
)

export default component.exports